import * as React from 'react';
import * as request from 'superagent';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';

import AppView from '~common/components/app-view/index';
import ErrorView from '~common/components/error-view';
import OverlayView from '~common/components/overlay';

import {Theme} from '@mui/styles';
import {APIError} from '~common/lib/types';
import LoadingView from '~common/components/loading-view';
import QueryList from '~common/components/query-fulfillment/query-list-fc';

import portalUserContext from '~common/lib/portal-user-context';
import URLManager from '~common/lib/url-manager';


import Require from "~common/components/require"

import {downloadFile} from '~common/lib/download-file';
import SuccessMessageView from "~common/components/success-view";




// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  status: 'loading' | 'ready' | 'error';
  error?: any;
  successMessage?: string;
  staticLocations?: Array<any>;
  staticVendors?: Array<any>;
  staticInvoiceTypes?: Array<any>;
};

class UserSubscriptionList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading'
    };
  }

 componentDidMount() {
    const st = this.state;
    st.status = 'ready';
    this.setState(st);

  }

  handleCriteriaFormSelection = (formDef: any): any => {

    for (const fi in formDef.predefined) {
      const field = formDef.predefined[fi];
      // console.log(field);
    }

    // console.log(formDef);
  };


  handleActionsForItemRow = (row: any) => {
    var actions = Array<any>();

    actions.push({
      label: 'Send Email',
      onClick: () => {
       request.put(`/api/portal-user-subscriptions/${row.id}/run`)
       .then(()=>{
          this.setState({
            successMessage: "subscription was succesful"
          })
       })
       .catch((err)=>{
          this.handleAPIError(err)
       })
      }
    })

    if (row.status == "Active") {
      actions.push({
        label: 'Unsubscribe',
        onClick: () => {
         request.put(`/api/portal-user-subscriptions/unsubscribe/${row.authToken}`)
         .then(()=>{
           // briefly display the success toaster
            this.setState({
              successMessage: "succesfully unsubscribed"
            }, ()=>{
             // reload the page. the subscription status changed to disabled. 
             setTimeout(()=>{
              window.location.reload()
            }, 2000)
            })
         })
         .catch((err)=>{
            this.handleAPIError(err)
         })
        }
      })
    }

    if (row.status == "Disabled") {
      actions.push({
        label: 'Resubscribe',
        onClick: () => {
          request.put(`/api/portal-user-subscriptions/resubscribe/${row.authToken}`)
          .then(()=>{
            // briefly display the success toaster
             this.setState({
               successMessage: "succesfully resubscribed"
             }, ()=>{
               // reload the page. the subscription status changed to disabled. 
              setTimeout(()=>{
                window.location.reload()
              }, 2000)
             })
          })
          .catch((err)=>{
             this.handleAPIError(err)
          })
         }
      })

      actions.push({
        label: 'Delete',
        onClick: () => {
          request.put(`/api/portal-user-subscriptions/delete/${row.authToken}`)
          .then(()=>{
            // briefly display the success toaster
             this.setState({
               successMessage: "succesfully deleted"
             }, ()=>{
               // reload the page. the subscription should be deleted. 
              setTimeout(()=>{
                window.location.reload()
              }, 2000)
             })
          })
          .catch((err)=>{
             this.handleAPIError(err)
          })
         }
      })
    }

    return actions;
  };

  handleRowClick = (row: any) => {
  //  window.location.href = `/payables/invoice-processing/tasks/${row.id}?q=${URLManager.getQueryStringValueByKey("q", window.location.href)}&returnURL=${window.location.pathname}?q=${URLManager.getQueryStringValueByKey("q", window.location.href)}`
  };

  onErrorViewClose = () => {
    this.setState({error: undefined})
  }

  handleSuccessMessageClose = () =>{
    this.setState({
      successMessage: undefined
    })
  }

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {status, error, successMessage} = this.state;

    var criteriaSelector = {
      module: 'subscriptions',
      form: 'userSubscriptionListCriteria',
      formType: 'userSubscriptionListCriteria'
    };

    criteriaSelector['userType'] = portalUserContext.userType;
    if (criteriaSelector['userType'] == 'Portal Admin') {
      criteriaSelector['userType'] = 'Internal';
    }

    var errorView;
		if (error) {
			errorView = <ErrorView classes={{}} error={error} onClose={this.onErrorViewClose} />;
		}

    var successMessageView
    if (successMessage) {
      successMessageView = (
        <SuccessMessageView
          onClose={this.handleSuccessMessageClose}
          classes={{}}
          message={successMessage}
        />
      );
    }

    switch (status) {
      case 'loading':
        return (
          <AppView>
            <div className={classes.container}>
              <LoadingView classes={{}} />
            </div>
          </AppView>
        );
      case 'error':
        return (
          <AppView>
            <div className={classes.container}>
              <ErrorView error={error} classes={} />
            </div>
          </AppView>
        );
      default:
        var overlayContent = null;
       

        return (
          <AppView>
            <Require classes={{}} requireOneOfFeatures={["subscription_user_list"]}>
              {errorView}
              {successMessageView}
             <div className={classes.container}>
              <QueryList
                criteriaFormSelector={criteriaSelector}
                resultsFormSelector={{
                  module: 'subscriptions',
                  form: 'userSubscriptionListResults',
                  formType: 'userSubscriptionListResults'
                }}
                queryUrl="/api/portal-user-subscriptions/list"
                autoQuery={true}
                excludeFromClear={}
                onCriteriaFormSelection={this.handleCriteriaFormSelection}
                supressSectionStatusIcon
                // onRowClick={this.handleRowClick}
                actionsForItemRow={this.handleActionsForItemRow}
                alwaysExecuteOnSubmit={true}
                forceExecuteOnLoad={true}
                customRenderers={}
                noResultsText="No Results Found"
                reserveRowActionSpace={true}
                pruneCriteriaForm={true}
                submitButtonText="Search"
              />
            </div>
            {overlayContent}
            </Require>
          </AppView>
        );
    }
  }
}

export default withStyles(styles)(UserSubscriptionList);
